import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, inject } from '@angular/core';
import { catchError, filter, startWith } from "rxjs/operators";
import { NavigationEnd, Router, RouterLink } from "@angular/router";
import { MatIconRegistry, MatIconModule } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { CoreUserProfileService, PingService, SoundService, UserProfile } from '@ftr/owa-core';
import { Subscription, throwError } from 'rxjs';
import { Location } from '@angular/common';
import { FirebaseAppMessagingService } from 'src/app/firebase/firebase.service';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyListModule } from '@angular/material/legacy-list';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [MatToolbarModule, MatLegacyTabsModule, RouterLink, MatIconModule, MatSidenavModule, MatLegacyListModule]
})
export class NavigationComponent implements OnInit, OnChanges, OnDestroy {
  private router = inject(Router);
  private location = inject(Location);
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);
  breakpointObserver = inject(BreakpointObserver);
  private _coreUserProfileService = inject(CoreUserProfileService);
  private _pingService = inject(PingService);
  private firebaseService = inject(FirebaseAppMessagingService);


  showBottomNav = false
  showLeftNav = true
  activeLinkIndex: number | null = null;
  public links: any[] = [];
  @Input() omegaMode: boolean = false;
  @Input() showUrgentMessageIcon: boolean = false;
  @Input() isOnLunch: boolean = false;
  @Input() showNewMessageNotification: boolean = false; 
  private profileSubscription!: Subscription;
  private currentProfile?: UserProfile;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOnLunch'] || changes['omegaMode']) {
      this.buildNavigationLinks();
      this.applyAuthorizationFilters();
    }

    this.matIconRegistry.addSvgIcon(
      "home",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/home.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "time",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/time.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "facilities",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/facilities.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "profile",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/profile.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "circle",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/circle.svg")
    );
    // this.firebaseService.showNewMessageNotification.subscribe({
    //   next: (val: any) => {
    //     this.showNewMessageNotification = val;
       
    //   }, error: (error: any) => {
    //     this.showNewMessageNotification = false;
    //   },
    //   complete: () => {
        
    //   }
    // })
 
  }
 

  private buildNavigationLinks(): void {
    if (this.omegaMode) {
      this.links = [
        {
          label: 'Time',
          href: '/omega/timekeeping',
          index: 0,
          icon: "time",
        },
        {
          label: 'Messages',
          href: '/omega/messages',
          index: 1,
          icon: "chat",
        },
        {
          label: 'Tools',
          href: '/omega/tools',
          index: 2,
          icon: "facilities",
        }
      ];
      return;
    }

    if (this.isOnLunch) {
      this.links = [
        {
          label: 'Home',
          href: '/home',
          index: 0,
          icon: "home",
        },
        {
          label: 'Profile',
          href: '/profile',
          index: 1,
          icon: "profile",
        }
      ];
    } else {
      this.links = [
        {
          label: 'Home',
          href: '/home',
          index: 0,
          icon: "home",
        },
        {
          label: 'Time',
          href: '/time',
          index: 1,
          icon: "time",
        },
        {
          label: 'Messages',
          href: '/messages',
          index: 2,
          icon: "chat",
        },
        {
          label: 'Tools',
          href: '/tools',
          index: 3,
          icon: "facilities",
        },
        {
          label: 'Profile',
          href: '/profile',
          index: 4,
          icon: "profile",
        }
      ];
    }
  }

  ngOnInit(): void {
    this.buildNavigationLinks();
    // this.breakpointObserver
    //     .observe(['min-width: 720px'])
    //     .subscribe((state: BreakpointState) => {
    //       console.log("state: ", state)
    //       if (state.matches) {
    //         this.showLeftNav = true;
    //         this.showBottomNav = false;
    //       }
    //       else {
    //         this.showLeftNav = false;
    //         this.showBottomNav = true;
    //       }
    //     });
    this.breakpointObserver.observe('(max-width: 720px)').subscribe(result => {
      console.log(result);
      if (!result.matches) {
        this.showLeftNav = true;
        this.showBottomNav = false;
      }
      else {
        this.showLeftNav = false;
        this.showBottomNav = true;
      }
    });
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      startWith({
        url: this.location.path()
      })
    ).subscribe((event) => {
      const url = (event as NavigationEnd).url.split('?')[0];
      if (this.omegaMode) {
        const matchedLink = [...this.links]
          .sort((a, b) => b.href.length - a.href.length)
          .find(link => url === link.href || url.startsWith(`${link.href}/`));
        this.activeLinkIndex = matchedLink?.index ?? null;
        return;
      }
      const link = this.links.find(link => url.startsWith(link.href));
      this.activeLinkIndex = link?.index ?? null;
    });

    this.profileSubscription = this._coreUserProfileService.profile.subscribe((profile: UserProfile) => {
      this.currentProfile = profile;
      this.buildNavigationLinks();
      this.applyAuthorizationFilters();
    });
  }

  private applyAuthorizationFilters(): void {
    const profile = this.currentProfile;
    if (profile && !this._coreUserProfileService.checkAuthorization('JOB', 'CanAccessJobs')) {
      this.links = this.links.filter(link => link.label !== 'Home');
    }
    if (profile && this._coreUserProfileService.isContractor && !this.omegaMode) {
      this.links = this.links.filter(link => link.label !== 'Time');
    }
  }

  ngOnDestroy(): void {
    this.profileSubscription?.unsubscribe();
  }

}
